import Controller from "@ember/controller"

export default class SignInController extends Controller {}
